import * as bytescale from "@bytescale/sdk";
import { safeParse } from "valibot";
import {
  type ClientAuthenticationArgs,
  ClientAuthenticationArgsSchema,
} from "./schema";

let canUpload = false;
export function getCanUpload() {
  return canUpload;
}

function waitForAuthSession() {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (bytescale.AuthManager.isAuthSessionReady()) {
        clearInterval(interval);
        resolve(true);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(interval);
      resolve(false);
    }, 10000);
  });
}

export async function uploadAuthentication(args: ClientAuthenticationArgs) {
  const result = safeParse(ClientAuthenticationArgsSchema, args);

  if (!result.success) {
    throw new Error(JSON.stringify(result.issues));
  }

  canUpload = result.output.canUpload;
  if (bytescale.AuthManager.isAuthSessionActive()) {
    await waitForAuthSession();
    return;
  }

  await bytescale.AuthManager.beginAuthSession({
    accountId: result.output.accountId,
    authUrl: result.output.authUrl,
    authHeaders: () => Promise.resolve({}),
    serviceWorkerScript: "/bytescale-auth-sw.js",
  });

  await waitForAuthSession();
}
